import React, { useEffect, useState, Suspense, lazy } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import { NavBar } from './components/layout/Navbar/Navbar';
import { About } from './components/About/About';
import { Footer } from './components/layout/Footer/Footer';
import { Resume } from './components/Resume/Resume';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { theme } from './theme/theme';
import { GlobalStyleOverrides } from './components/common/components';
import { ScrollToTop } from './components/common/ScrollToTop';
import { loadFull } from 'tsparticles';
import { initParticlesEngine } from '@tsparticles/react';
import { Engine, Container } from '@tsparticles/engine';
const Particle = lazy(() =>
  import('./components/common/Particle').then(module => ({
    default: module.Particle,
  }))
);
import { Home } from './components/Home/Home';
import { PreLoader } from './components/common/PreLoader/PreLoader';
import { Engineering } from './components/Engineering/Engineering';

const App = (): React.ReactNode => {
  const [load, updateLoad] = useState<boolean>(true);
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine: Engine) => {
      await loadFull(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      updateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const particlesLoaded = (
    container?: Container | undefined
  ): Promise<void> => {
    console.log(container);
    return Promise.resolve();
  };

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyleOverrides />
      <Router>
        <CssBaseline />
        <PreLoader load={load} />
        <Box
          className='App'
          id={load ? 'no-scroll' : 'scroll'}
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100vh',
            color: 'text.primary',
            position: 'relative',
          }}
        >
          {init && (
            <Suspense fallback={null}>
              <Particle particlesLoaded={particlesLoaded} />
            </Suspense>
          )}
          <NavBar />
          <ScrollToTop />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/resume' element={<Resume />} />
            <Route path='/engineering' element={<Engineering />} />
          </Routes>
          <Footer />
        </Box>
      </Router>
    </ThemeProvider>
  );
};

export default App;
